import { request } from "@/global/config/request";
import { AxiosResponse } from "axios";

export function findFontsInGraphic(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return request.get(`/projects/${projectUuid}/fonts`, {
        params: {
            ...params,
        }
    })
}

export function findFontTtfs(params?: {}): Promise<AxiosResponse<any>> {
    return request.get(`/fonts/ttfs`, {
        params: {
            ...params,
        }
    })
}

export function findFontGlyphs(params?: {}): Promise<AxiosResponse<any>> {
    return request.get(`/fonts/glyphs`, {
        params: {
            ...params,
        }
    })
}